import { Container, Section } from "../../components/section";
import { useDispatch, useSelector } from "react-redux";

import { ContactForm } from "./ContactForm";
import { CreateContact } from "../../redux/contact";
import { ErrorBanner } from "../../components/banner";
import { Loading } from "../../components/loader";
import { useNavigate } from "react-router-dom";

export const ContactCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.contacts);

  const onFormSubmit = async (values) => {
    await dispatch(CreateContact(values));

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/messages");
      }, 500);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Section>
      <Container width="70">
        {error && <ErrorBanner text={error} />}
        <ContactForm onFormSubmit={onFormSubmit} />
      </Container>
    </Section>
  );
};
